.headerContainer {
}

.menuItem {
  color: var(--mantine-color-white);
  opacity: 0.4;
  text-decoration: none;

  &[data-active='true'],
  &:hover {
    opacity: 1;
    text-decoration: none;
  }
}
